import React from 'react';
import {Redirect} from 'react-router-dom';

const AdminHome = () => (
  <Redirect to="/admin/login"/>
);

export default AdminHome;



// WEBPACK FOOTER //
// ./src/components/admin/home/index.jsx